/**
 * Notification Types and Models
 * Production-ready notification system for admin dashboard
 */

export enum NotificationType {
  ORDER_NEW = 'ORDER_NEW',
  ORDER_UPDATE = 'ORDER_UPDATE',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  PRODUCT_LOW_STOCK = 'PRODUCT_LOW_STOCK',
  PRODUCT_OUT_OF_STOCK = 'PRODUCT_OUT_OF_STOCK',
  DELIVERY_ASSIGNED = 'DELIVERY_ASSIGNED',
  DELIVERY_COMPLETED = 'DELIVERY_COMPLETED',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
  SYSTEM_ALERT = 'SYSTEM_ALERT',
  USER_REGISTERED = 'USER_REGISTERED',
}

export enum NotificationPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export interface Notification {
  id: string;
  type: NotificationType;
  priority: NotificationPriority;
  title: string;
  message: string;
  isRead: boolean;
  createdAt: Date;
  readAt?: Date;
  
  // Related entity information
  relatedEntityId?: string; // Order ID, Product ID, etc.
  relatedEntityType?: 'order' | 'product' | 'user' | 'delivery';
  
  // Additional metadata
  metadata?: Record<string, any>;
  
  // Action buttons (optional)
  actionUrl?: string;
  actionLabel?: string;
}

export interface NotificationFormData {
  type: NotificationType;
  priority: NotificationPriority;
  title: string;
  message: string;
  relatedEntityId?: string;
  relatedEntityType?: 'order' | 'product' | 'user' | 'delivery';
  metadata?: Record<string, any>;
  actionUrl?: string;
  actionLabel?: string;
}

export interface NotificationStats {
  total: number;
  unread: number;
  byType: Record<NotificationType, number>;
  byPriority: Record<NotificationPriority, number>;
}

export interface NotificationFilter {
  type?: NotificationType;
  priority?: NotificationPriority;
  isRead?: boolean;
  startDate?: Date;
  endDate?: Date;
}
